const DEFAULT_FORMATTER = (row, cell, value) => {
  value = value || value == 0 ? value : '';
  if (typeof value !== 'object') return value.toString(); // Pass string/numeric values back
  return value.displayValue ? value.displayValue : '-';
};

const BOOLEAN_FORMATTER = (row, cell, value) => {
  return BASE_BOOLEAN_FORMATTER(value);
};

const BASE_BOOLEAN_FORMATTER = (value) => {
  if (!(value === true || value === false)) return '';
  return value ? 'Yes' : 'No';
};

const PART_FORMATTER = (row, cell, value, columnDef, dataContext) => {
  const productPage = dataContext.productPage;
  let partNumber = typeof value !== 'object' ? value : value.displayValue;

  if (productPage && partNumber) {
    return `<span class="${partNumber.toLowerCase()}-part-number-cell part-number-cell">${partNumber}</span><a target="_blank" href="${productPage}"><span class="link-icon-cell"><img src="images/new-tab_icon_blue.png"></span></a>`;
  } else if (partNumber) {
    return `<span class="${partNumber.toLowerCase()}-part-number-cell part-number-cell">${partNumber}</span>`;
  }
};

export { DEFAULT_FORMATTER, BOOLEAN_FORMATTER, BASE_BOOLEAN_FORMATTER, PART_FORMATTER };
